import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Activities } from "src/modules/activity-log/activity";
import RoundButton from "../../RoundButton";
import { Caption } from "src/atoms/typography";

import { ReactComponent as ManageIcon } from "src/icons/more-horiz.svg";

export default function ManageCommandButton({
  isDarkMode,
  mode,
  activity,
  onClick,
  ...rest
}) {
  const { t } = useTranslation();
  let bg;
  if (
    mode === "audio" &&
    (activity === Activities.SLEEPING || activity === Activities.MOTION)
  ) {
    bg = "black8";
    if (isDarkMode) bg = "white20";
  } else {
    bg = "black20";
  }

  return (
    <Flex flexDirection="column" alignItems="center" {...rest}>
      <RoundButton
        icon={ManageIcon}
        iconFill={
          mode === "video" || activity === Activities.AWAKE || isDarkMode
            ? "white"
            : "black54"
        }
        iconSize="50%"
        size={["40px", "56px", "64px"]}
        bg={bg}
        mb="4px"
        onClick={onClick}
      />
      <Caption
        fontSize={["10px", "14px", "16px"]}
        color={
          isDarkMode || mode === "video" || activity === Activities.AWAKE
            ? "white70"
            : "black54"
        }
      >
        {t("buttons.manage")}
      </Caption>
    </Flex>
  );
}
